import type { LimuloAzionePendente } from './azionePersistente';

/**
 * **La sfida di PIATTAFORMA in arrivo, come riga della barra** (T2-5, lotto B1): l'unica sfida della
 * barra, letta da `GET /v1/challenges` (Limulo). Pura: nessuna decisione qui su SE mostrarla.
 *
 * ⛔ La chiave e' `sfida-piattaforma:<challengeId>`, mai `sfida:<...>`: quel prefisso era della riga del
 * ponte (`sfida:<codice dell'invito>`), tolta col lotto C2. Resta riservato, e la chiave di piattaforma
 * non lo riusa: due insiemi con lo stesso prefisso si scontrerebbero al primo id che somiglia a un codice.
 * ⛔ `tournamentId` porta il `challengeId` (riuso deliberato del campo): la sfida non ha ancora un
 * torneo, e questa riga non lo legge mai come tale.
 * `testo` e' la frase gia' composta e localizzata («<chi> ti sfida a <gioco>»): la riga la mostra
 * come titolo. ⛔ `destinazione: null`: corpo INERTE (v. `LimuloAzionePendente.destinazione`).
 */
export function rigaSfidaPiattaforma(input: {
  challengeId: string;
  testo: string;
  nomeSfidante: string | null;
  scadenza: string | null;
  onAccetta: () => void;
  onRifiuta: () => void;
  accettando: boolean;
  rifiutando: boolean;
  errore: string | null;
  esito: string | null;
  /** kb#388: la frase neutra «Sto collegando…» mentre il tocco aspetta il sync del profilo; `null` altrimenti. */
  collegando?: string | null;
}): LimuloAzionePendente {
  return {
    chiave: `sfida-piattaforma:${input.challengeId}`,
    tipo: 'sfida',
    tournamentId: input.challengeId,
    matchId: null,
    torneo: input.testo,
    round: null,
    scadenza: input.scadenza,
    tag: null,
    avversario: input.nomeSfidante,
    // SENZA destinazione: la sfida non ha ancora una pagina sua, e la riga non deve portare in un posto
    // inventato ne' sparire dalla barra su una pagina qualunque (`senzaDestinazione`).
    destinazione: null,
    pulsantiSfida: {
      onAccetta: input.onAccetta,
      onRifiuta: input.onRifiuta,
      accettando: input.accettando,
      rifiutando: input.rifiutando,
      errore: input.errore,
      esito: input.esito,
      collegando: input.collegando ?? null,
    },
  };
}
